export default "/images/ico-time.svg?9988a16708e6dd68be114f02ca73b4a8";